import { render } from "./DeleteCampaignAction.vue?vue&type=template&id=19f510ee"
import script from "./DeleteCampaignAction.vue?vue&type=script&lang=ts"
export * from "./DeleteCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script